import script from "./mainHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./mainHeader.vue?vue&type=script&setup=true&lang=ts"

import "./mainHeader.vue?vue&type=style&index=0&id=61a8e3e1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61a8e3e1"]])

export default __exports__